export default {"src":"/_next/static/media/logo-label.343b9a96.svg","height":20,"width":101};